/**
 * Generated by orval v6.17.0 🍺
 * Do not edit manually.
 * Gatti Filtrazioni
 * OpenAPI spec version: v1
 */
import axios from "axios";
import type { AxiosRequestConfig, AxiosResponse, AxiosError } from "axios";
import { useQuery, useMutation } from "@tanstack/react-query";
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey,
} from "@tanstack/react-query";
import type {
  UserLoginResponseDto,
  UserLoginRequestDto,
  ForgotPasswordRequestDto,
  CompleteForgotPasswordResponseDto,
  CompleteForgotPasswordRequestDto,
} from ".././models";

export const login = (
  portale: 1 | 2 | 3,
  userLoginRequestDto: UserLoginRequestDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<UserLoginResponseDto>> => {
  return axios.post(
    `/api/portali/${portale}/auth/login`,
    userLoginRequestDto,
    options
  );
};

export const getLoginMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { portale: 1 | 2 | 3; data: UserLoginRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof login>>,
  TError,
  { portale: 1 | 2 | 3; data: UserLoginRequestDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof login>>,
    { portale: 1 | 2 | 3; data: UserLoginRequestDto }
  > = (props) => {
    const { portale, data } = props ?? {};

    return login(portale, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof login>>
>;
export type LoginMutationBody = UserLoginRequestDto;
export type LoginMutationError = AxiosError<unknown>;

export const useLogin = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof login>>,
    TError,
    { portale: 1 | 2 | 3; data: UserLoginRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getLoginMutationOptions(options);

  return useMutation(mutationOptions);
};
export const signInAsUser = (
  userIdToImpersonate: number,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/auth/signInAsUser/${userIdToImpersonate}`,
    undefined,
    options
  );
};

export const getSignInAsUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInAsUser>>,
    TError,
    { userIdToImpersonate: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof signInAsUser>>,
  TError,
  { userIdToImpersonate: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof signInAsUser>>,
    { userIdToImpersonate: number }
  > = (props) => {
    const { userIdToImpersonate } = props ?? {};

    return signInAsUser(userIdToImpersonate, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SignInAsUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof signInAsUser>>
>;

export type SignInAsUserMutationError = AxiosError<unknown>;

export const useSignInAsUser = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof signInAsUser>>,
    TError,
    { userIdToImpersonate: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getSignInAsUserMutationOptions(options);

  return useMutation(mutationOptions);
};
export const logout = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(`/api/auth/logout`, undefined, options);
};

export const getLogoutMutationOptions = <
  TError = AxiosError<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    TVariables,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof logout>>,
  TError,
  TVariables,
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof logout>>,
    TVariables
  > = () => {
    return logout(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type LogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof logout>>
>;

export type LogoutMutationError = AxiosError<unknown>;

export const useLogout = <
  TError = AxiosError<unknown>,
  TVariables = void,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof logout>>,
    TError,
    TVariables,
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getLogoutMutationOptions(options);

  return useMutation(mutationOptions);
};
export const currentUser = (
  options?: AxiosRequestConfig
): Promise<AxiosResponse<UserLoginResponseDto>> => {
  return axios.get(`/api/auth/me`, options);
};

export const getCurrentUserQueryKey = () => [`/api/auth/me`] as const;

export const getCurrentUserQueryOptions = <
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof currentUser>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryOptions<Awaited<ReturnType<typeof currentUser>>, TError, TData> & {
  queryKey: QueryKey;
} => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCurrentUserQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof currentUser>>> = ({
    signal,
  }) => currentUser({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions };
};

export type CurrentUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof currentUser>>
>;
export type CurrentUserQueryError = AxiosError<unknown>;

export const useCurrentUser = <
  TData = Awaited<ReturnType<typeof currentUser>>,
  TError = AxiosError<unknown>
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof currentUser>>,
    TError,
    TData
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getCurrentUserQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const forgotPassword = (
  portale: 1 | 2 | 3,
  forgotPasswordRequestDto: ForgotPasswordRequestDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/api/portali/${portale}/auth/forgotPassword`,
    forgotPasswordRequestDto,
    options
  );
};

export const getForgotPasswordMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { portale: 1 | 2 | 3; data: ForgotPasswordRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof forgotPassword>>,
  TError,
  { portale: 1 | 2 | 3; data: ForgotPasswordRequestDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof forgotPassword>>,
    { portale: 1 | 2 | 3; data: ForgotPasswordRequestDto }
  > = (props) => {
    const { portale, data } = props ?? {};

    return forgotPassword(portale, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof forgotPassword>>
>;
export type ForgotPasswordMutationBody = ForgotPasswordRequestDto;
export type ForgotPasswordMutationError = AxiosError<unknown>;

export const useForgotPassword = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof forgotPassword>>,
    TError,
    { portale: 1 | 2 | 3; data: ForgotPasswordRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};
export const completeForgotPassword = (
  completeForgotPasswordRequestDto: CompleteForgotPasswordRequestDto,
  options?: AxiosRequestConfig
): Promise<AxiosResponse<CompleteForgotPasswordResponseDto>> => {
  return axios.post(
    `/api/auth/completeForgotPassword`,
    completeForgotPasswordRequestDto,
    options
  );
};

export const getCompleteForgotPasswordMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeForgotPassword>>,
    TError,
    { data: CompleteForgotPasswordRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeForgotPassword>>,
  TError,
  { data: CompleteForgotPasswordRequestDto },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeForgotPassword>>,
    { data: CompleteForgotPasswordRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return completeForgotPassword(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeForgotPassword>>
>;
export type CompleteForgotPasswordMutationBody =
  CompleteForgotPasswordRequestDto;
export type CompleteForgotPasswordMutationError = AxiosError<unknown>;

export const useCompleteForgotPassword = <
  TError = AxiosError<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeForgotPassword>>,
    TError,
    { data: CompleteForgotPasswordRequestDto },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationOptions = getCompleteForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

export const __$$useLogin = () =>
  //@ts-ignore
  useLogin(...([] as any[]));

export const __$$useSignInAsUser = () =>
  //@ts-ignore
  useSignInAsUser(...([] as any[]));

export const __$$useLogout = () =>
  //@ts-ignore
  useLogout(...([] as any[]));

export const __$$useCurrentUser = () =>
  //@ts-ignore
  useCurrentUser(...([] as any[]));

export const __$$useForgotPassword = () =>
  //@ts-ignore
  useForgotPassword(...([] as any[]));

export const __$$useCompleteForgotPassword = () =>
  //@ts-ignore
  useCompleteForgotPassword(...([] as any[]));
